import { gql } from 'apollo-angular';

// Attached file
export const attachedFileFragment = gql`
  fragment AttachedFile on AttachedFile {
    id
    createdAt
    contentType
    fileName
    fileSize
    humanFileSize
    url
    updatedAt
  }
`;
